import { cn } from '~/shared/lib/cn'
import { Text } from '~/shared/ui'

export function MessageList({
  title,
  items,
  isError = false,
}: {
  title: string
  items: string[]
  isError?: boolean
}) {
  if (items.length === 0) return null

  return (
    <div>
      <Text
        className={cn({ 'text-error-main': isError })}
        appearance="SUBTITLE2"
      >
        {`${title} (${items.length})`}
      </Text>
      <ul className="m-0 mt-1 flex list-disc flex-col gap-1 pl-5">
        {items.map((item, index) => (
          <li
            key={index}
            className="text-[13px] leading-5 wrap-anywhere whitespace-pre-wrap"
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}
